const capitalize = (string: string): string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const localeField = (data: any, fieldName: string, locale: string) => {
    if (typeof data !== 'object') return '';

    let result = Object.prototype.hasOwnProperty.call(data, fieldName) ? data[fieldName] : '';

    let localizedName = locale === 'ru' ? fieldName : fieldName.replace('_ru', '') + '_' + locale;

    const fieldNameCamelCaseMatched = fieldName.match(/(.+)(.{2})/);
    
    if (fieldNameCamelCaseMatched && fieldNameCamelCaseMatched[2] === 'Ru') {
        localizedName = locale === 'ru' ? fieldName : fieldName.substring(0, fieldName.length - 2) + capitalize(locale);        
    }

    if (Object.prototype.hasOwnProperty.call(data, localizedName) && data[localizedName]) {
        result = data[localizedName];
    }

    return result;
};

export default localeField;
